<template>
  <div class="Melamine">
    <div class="title">2-Ethylhexyl Acrylate</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Item" label="Item"> </el-table-column>
        <el-table-column prop="Specification" label="Specification">
        </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>180KG/Drum, ISO tank, bulk</p>
    </div>
    <div class="item-huanhang">
      <label>Applications:</label>
      <p>
        2-ethylhexyl acrylate is used in the production of honnopolymers. It is
        also used in the production of co-polymers, for example acrylic acid and
        its salts, esters, amides, methacrylates, acrylonitrile, maleates, vinyl
        acetate, vinyl chloride, vinylidene chleoride, styrene, butadiene and
        unsaturated polyesters. 2-ethylhexyl acrylate is also used inpressuree
        sensitive adhesives. When used in latex paint formulations acrylic
        polymers have good water resistaance, low temperature flexibility and
        excellent weathering and sunlight resistance.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          Item: "appearance",
          Specification:
            "Colorless transparent liquid with a characteristic odor",
        },
        { Item: "Purity≥%(GC)", Specification: "99.5" },
        { Item: "Water≤Wt,%", Specification: "0.05" },
        { Item: "Color(APHA)≤", Specification: "10" },
        { Item: "Acidity(ASAA)≤Wt,%", Specification: "0.01" },
        {
          Item: "Inhibitor (MEHQ) Wt.ppm",
          Specification:
            "15+5(As agreed upon between the buyer and the seller)",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
